import { useDisclosure, useLocalStorage } from "@mantine/hooks";

import { DISCLAIMER_MODAL_KEYS } from "#shared/constants";

export function useBatchDisclaimerModal() {
  const [modalOpened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const [dontShowAgain, setDontShowAgain] = useLocalStorage({
    key: DISCLAIMER_MODAL_KEYS.BATCH,
    defaultValue: false,
  });

  const shouldShowModal = (isAlreadyABatch: boolean) => !dontShowAgain && !isAlreadyABatch;

  const checkboxProps = {
    id: DISCLAIMER_MODAL_KEYS.BATCH,
    checked: dontShowAgain,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => setDontShowAgain(e.currentTarget.checked),
  };

  const handleConfirm = (onConfirm: () => void) => {
    if (dontShowAgain) {
      setDontShowAgain(true);
    }
    onConfirm();
    closeModal();
  };

  return {
    shouldShowModal,
    modalOpened,
    openModal,
    closeModal,
    handleConfirm,
    checkboxProps,
  };
}
